module.exports = __webpack_public_path__ + "static/img/A.O.史密斯自旋式洁霸洗碗机R5.82d5d020.png";